
import AppExtraFieldsEdit from "@/components/ExtraFieldsEdit.vue";
import Vue from "vue";
import {IExtraFields} from "@/utils/models/extra-fields";
import {ExtraFieldNamesConfig} from "@/models/dossier-configs/extra-field-names-config";

export default Vue.extend({
	props: {
		value: {
			type: Object as () => IExtraFields,
			required: true
		},
		nameSettings: {
			type: Object as () => ExtraFieldNamesConfig,
			required: true
		},
	},
	methods: {
		close() {
			this.$emit("close");
		},
		confirm() {
			this.$emit("update");
		},
	},
	components: {
		AppExtraFieldsEdit
	}
});
